import TagsList from "@/components/PostTagsList";
import Title from "./Title";
import Thumb from "./Thumb";
import Share from "./Share";
import { CommentIcon } from "_c/Icon";
import { CircleButton } from "@/components/Button";
import { useSuspenseQuery } from "@tanstack/react-query";
import { QueryKeysConfig } from "@/config/query-keys";
import cls from "./styles.module.css";
import { useScrollRestoration } from "@/hooks/use-scroll-restoration";
import { usePostBySlugLoader } from "@/hooks/network/use-post-by-slug-loader";
import Observations from "./Observations";
import Like from "./Like";
import CommentsSection from "./CommentsSection";
import { withSuspenseBoundary } from "@/components/withSuspenseBoundary";
import Loading from "./loading";
import { withQueryErrorResetBoundary } from "@/components/ErrorBoundary/withQueryErrorResetBoundary";
import { LinkBuilder } from "@/services/link-builder";
import PostMetadata from "@/components/PostMetadata";
import FormattedDate from "@/components/FormattedDate";

type TProps = {
  slug: string;
};
function PostScreen({ slug }: TProps) {
  const getPost = usePostBySlugLoader();
  const { data: post } = useSuspenseQuery({
    queryKey: [QueryKeysConfig.postBySlug, { slug }],
    queryFn: () => getPost({ data: { slug } }),
  });
  const postId = post.id;
  const categoryName = post.categories[0]?.name;
  useScrollRestoration(`post-${slug}`);
  const title = post.title ?? "";
  const addCommentTitle = "Оставить комментарий";
  return (
    <div className={cls.root}>
      <header className={cls.header}>
        <div className={cls.category}>{categoryName}</div>
        <Title title={title} />
        <FormattedDate isSSR date={post.date} />
        <PostMetadata
          className={cls.metadata}
          likesCount={post.likesCount}
          observationsCount={post.observations.length}
          photosCount={post.photosCount}
          commentsCount={post.commentsCount}
        />
      </header>
      {post.thumbnail && <Thumb postId={postId} thumbnail={post.thumbnail} />}
      <article
        className={cls.article}
        dangerouslySetInnerHTML={{
          __html: post.content,
        }}
      />
      <TagsList tags={post.tags} />
      <div className={cls.actions}>
        <Share
          link={LinkBuilder.build({
            route: "post",
            slug,
            isAbsolute: true,
          })}
          excerpt={post.excerpt}
          picture={post.thumbnail?.url}
          title={title}
          slug={post.slug}
        />
        <Like postId={postId} />
        <CircleButton
          onClick={() => {
            const $el = document.querySelector(
              "#comment-form_message",
            ) as HTMLInputElement;
            $el.focus();
          }}
          aria-label={addCommentTitle}
          title={addCommentTitle}
          className={cls.commentBtn}
        >
          <CommentIcon size={32} aria-hidden />
        </CircleButton>
      </div>
      <Observations observations={post.observations} />
      <CommentsSection commentsCount={post.commentsCount} postId={postId} />
    </div>
  );
}

export default withQueryErrorResetBoundary(
  withSuspenseBoundary(PostScreen, <Loading />),
);
